import {redirects as base_redirects} from '@hello10/shared-client';

const redirects = {
  ...base_redirects
};

export default redirects;
